import { defineComponent } from "vue";
import { Log } from "~/extensions/utils";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { store } from "./store/PasswordReissueStore";
const log = Log.create("PasswordReissueCompletePage");
export default defineComponent({
    name: "PasswordReissueCompletePage",
    beforeRouteEnter(to, from, next) {
        if (from.name !== "password-reissue-check") {
            next({ name: "password-reissue-entry" });
            return;
        }
        if (isNullOrUndefined(store.mailAddress) || store.mailAddress === "" || isNullOrUndefined(store.authCode) || store.authCode === "") {
            next({ name: "password-reissue-entry" });
            return;
        }
        next();
    },
    setup() {
        store.clear();
        return {};
    }
});
